import { ResponseStatusEnum } from "@clockwise/schema";
import React from "react";
import { Async } from "../atoms/Async";

import { Button, ButtonSet } from "@clockwise/design-system";

export const ECResponseStatus = ({
  onRSVPChange,
  rsvpStatus,
  loading,
}: {
  onRSVPChange: (value: ResponseStatusEnum) => void;
  rsvpStatus: ResponseStatusEnum;
  loading: boolean;
}) => {
  const onRSVPYes = () => {
    onRSVPChange(ResponseStatusEnum.Accepted);
  };
  const onRSVPMaybe = () => {
    onRSVPChange(ResponseStatusEnum.Tentative);
  };
  const onRSVPNo = () => {
    onRSVPChange(ResponseStatusEnum.Declined);
  };

  const acceptedSelected = rsvpStatus === ResponseStatusEnum.Accepted;
  const maybeSelected = rsvpStatus === ResponseStatusEnum.Tentative;
  const declinedSelected = rsvpStatus === ResponseStatusEnum.Declined;

  return (
    <Async loading={loading} loadingWidth="90px" loadingHeight="28px">
      <div className="cw-flex cw-justify-between cw-items-center">
        <span className="cw-body-sm cw-text-muted">Are you attending?</span>
        <ButtonSet variant="default">
          <Button
            size="xsmall"
            aria-label={`RSVP Yes, ${acceptedSelected ? "selected" : "not selected"}`}
            variant="outlined"
            sentiment={acceptedSelected ? "positive" : "neutral"}
            rounded
            onClick={onRSVPYes}
          >
            Yes
          </Button>
          <Button
            size="xsmall"
            aria-label={`RSVP No, ${declinedSelected ? "selected" : "not selected"}`}
            variant="outlined"
            sentiment={declinedSelected ? "positive" : "neutral"}
            rounded
            onClick={onRSVPNo}
          >
            No
          </Button>
          <Button
            size="xsmall"
            aria-label={`RSVP Maybe, ${maybeSelected ? "selected" : "not selected"}}`}
            variant="outlined"
            sentiment={maybeSelected ? "positive" : "neutral"}
            rounded
            onClick={onRSVPMaybe}
          >
            Maybe
          </Button>
        </ButtonSet>
      </div>
    </Async>
  );
};
